import React from "react";

const Row = ({ label, value }) => {
  if (!value) return null;
  return (
    <div className="col-12 col-md-6 d-flex">
      <div className="fw-semibold me-2" style={{ minWidth: 140 }}>{label}:</div>
      <div className="text-muted">{value}</div>
    </div>
  );
};

const JobProfileCard = ({ job, title }) => {
  return (
    <section className="card border-0 shadow-sm my-4">
      <div className="card-body">
        <h6 className="fw-semibold mb-3" style={{ color: "#008080" }}>
          {title} job profile
        </h6>
        <div className="row g-2">
          <Row label="Job title" value={title} />
          <Row label="Location" value={job.Governorate__c} />
          <Row label="Job Type" value={job.Job_Type__c} />
          <Row label="Department" value={job.Department__c} />
          <Row label="Related" value={job.Related_Position__c} />
          <Row label="Direct Leader" value={job.Direct_Leader__c} />
          <Row label="Experience Level" value={job.Experience_Level__c} />
        </div>
      </div>
    </section>
  );
};

export default JobProfileCard;
